import { Fields } from 'src/components/CustomisationPage/feature/customisation.types';

export const ARTWORK_FORM_FIELD = `bundle-customisation`;
export const ARTWORK_FORM_PREFIX = `${ARTWORK_FORM_FIELD}.`;
export const ARTWORK_FORM_LOCATION_PREFIX = `bundle-customisation-location`;
export const BUNDLE_ARTWORK_FIELD = Fields.artwork;
